import { render } from "./UiPropBorder.vue?vue&type=template&id=1a7c641c"
import script from "./UiPropBorder.vue?vue&type=script&lang=js"
export * from "./UiPropBorder.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__